module.exports = __webpack_public_path__ + "fonts/DM_Sans-300-latin-ext6.0d3827b.woff2";